import angular from 'angular';
import ServicesModule from '../../../services/services';
import ResourcesModule from '../../../resources/resources';
import template from './gameDevelopersIndex.jade';
import requestAccessModalTemplate from './requestAccessModal.jade';

export class GameDevelopersIndexController {
  /* @ngInject */
  constructor($window, $filter, GameDevelopersResource, AllGameDevelopersResource, ggTable, ModalService, notify, UserAccessRequestsResource) {
    this.$window = $window;
    this.translateWith = $filter('translateWith');
    this.GameDevelopersResource = GameDevelopersResource;
    this.AllGameDevelopersResource = AllGameDevelopersResource;
    this.ModalService = ModalService;
    this.notify = notify;
    this.UserAccessRequestsResource = UserAccessRequestsResource;
    this.getResources();
    this.resourcesTable = new ggTable({count: 30});
  }

  getResources() {
    this.GameDevelopersResource.getList().then((res) => {
      this.resourcesTable.loadData(res);
    });
  }

  openRequestAccess() {
    this.AllGameDevelopersResource.getList()
      .then((gameDevelopers) => this.showRequestAccessModal(gameDevelopers))
      .catch(this.notify.apiError);
  }

  showRequestAccessModal(gameDevelopers) {
    this.ModalService.showModal({
      template: requestAccessModalTemplate(),
      controllerAs: 'vm',
      controller: function (gameDevelopers, close) {
        this.gameDevelopers = gameDevelopers;
        this.selected = null;
        this.close = close;
      },
      inputs: {gameDevelopers}
    }).then((modal) => {
      modal.close.then((selected) => {
        if (!selected) {
          return;
        }
        this.UserAccessRequestsResource.one('game_developer').customPOST(null, selected.id)
          .then(() => this.notify.success('accessRequested'))
          .catch(this.notify.apiError);
      });
    });
  }

  remove(resource) {
    if (!this.$window.confirm(this.translateWith('confirmDelete', resource.company_name)))
      return false;

    resource.remove();
    this.resourcesTable.remove(resource);
  }
}

export function GameDevelopersIndexComponent() {
  return {
    template,
    controller: GameDevelopersIndexController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      title: '='
    },
    bindToController: true
  };
}

export default angular.module('app.components.admin.gameDevelopers.index', [
  'angularModalService',
  ServicesModule.name,
  ResourcesModule.name
])
.directive('gameDevelopersIndex', GameDevelopersIndexComponent);



/** WEBPACK FOOTER **
 ** ./src/components/admin/gameDevelopers/gameDevelopersIndex.js
 **/